// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IRoomCountFilterSchema {
  /** UI значение для фильтра (Н-р: Студия) **/
  name: string;
  /** Возможные значения фильтра **/
  value: EValue;
}

export enum EValue {
  /** Четырехкомнатная квартира **/
  'FourRoom' = 'fourRoom',
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Студия **/
  'Studio' = 'studio',
  /** Трехкомнатная квартира **/
  'ThreeRoom' = 'threeRoom',
  /** Двухкомнатная квартира **/
  'TwoRoom' = 'twoRoom',
}
